import { List, Map, Record } from 'immutable'

import { AudienceType, AnswerType, KeywordType, CtaTypes, RoutingType } from './constants'

export const Cta = Record({
  type: CtaTypes.NONE,
  url: 'https://drift.com',
  copy: 'Learn More',
})

export const RoutingOption = Record({
  type: null,
})

export const SingleRoutingOption = Record({
  type: RoutingType.SINGLE,
  userId: null,
})

export const GroupRoutingOption = Record({
  type: RoutingType.GROUP,
  userIds: null,
})

export const Goal = Record({
  id: undefined,
  name: undefined,
  playbookId: undefined,
  routing: null,
  classification: Map(),
  message: null,
  schedule: null,
  markCQL: null,
  statusChange: null,
})

export const SmartFilters = Record({
  meetingScheduled: null,
  salesSequenceEngaged: null,
  chatEngaged: null,
})

export const Targeting = Record({
  id: null,
  userListIds: List(),
  accountListIds: List(),
  excludedUserListIds: List(),
  excludedAccountListIds: List(),
  display: List(),
  audience: AudienceType.NONE,
  dueAt: null,
  campaignReenrollmentType: null,
  unenrollOnReply: null,
  unenrollOnReplyByDomain: null,
  smartFilters: SmartFilters(),
})

export const ConditionSet = Record({
  id: undefined,
  conditions: List(),
})

export const Condition = Record({
  id: undefined,
  value: List.of(''),
  operator: 'includesAnyOf',
  field: 'url',
})

export const Email = Record({
  message: '',
  title: '',
  delay: 3,
  delayUnit: 'DAYS',
  id: undefined,
  threadedWithPrevious: undefined,
  bannerImageUrl: null,
  campaignId: null,
  sendFromOverride: null,
  senderEmailOverride: null,
  dynamicAccountSendAttribute: null,
  dynamicSenderFormat: null,
})

export const Signature = Record({
  id: null,
  signatureId: null,
  signatureBody: null,
  authorId: null,
  includeAvatar: false,
  includeCompanySocialMedia: false,
  hasCampaignGraphic: false,
  campaignGraphic: null, // URL for the image
  campaignGraphicLink: null, // URL for the link wrapping the image
})

export const Sequence = Record({
  emails: List(),
  options: Map(),
})

export const Question = Record({
  id: null,
  prompt: '',
  defaultAnswerId: null,
  answers: List(),
  status: 'ENABLED',
  actionId: null,
  interactionId: null,
  isButtonOnly: null,
  fieldConfiguration: null,
})

export const Interaction = Record({
  id: null,
  name: 'Sample LeadBot',
  slug: null,
  greeting: 'Hey there!',
  questions: List(),
  actionTypeId: null,
  campaignId: null,
})

export const Answer = Record({
  id: null,
  response: '',
  keywords: List(),
  skipTo: null,
  skipToGoal: null,
  type: AnswerType.BUTTON,
  validationType: null,
  validationConfig: Map(),
  buttonText: '',
  questionId: null,
})

export const FieldConfiguration = Record({
  fieldName: null,
})

export const Keyword = Record({
  id: null,
  text: '',
  type: KeywordType.CONTAINS,
  special: false,
  answerId: null,
})

export const PlaybookMeta = Record({
  autoArchived: false,
  driftLinkOnly: false,
})

export const Playbook = Record({
  id: undefined,
  meta: PlaybookMeta(),
  priority: undefined,
  createdAt: undefined,
  createdAuthorId: undefined,
  updatedAt: undefined,
  updatedAuthorId: undefined,
  name: 'New Playbook',
  reportType: undefined,
  status: undefined,
  actions: List(),
  goals: List(),
  targeting: Targeting(),
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/playbook/models.js